const FittingStationFinderConstants = {
    LIGHTBOX_PAGE_USAGE_DESCRIPTION: 0,
    LIGHTBOX_PAGE_FINDER: 1,
    LIGHTBOX_PAGE_SUCCESS_PAGE: 2,
    FITTING_STATIONS_WITH_FROM_PRICE_APIPATH: '/fittingstation/getstationsfrom/',
    FITTING_STATIONS_FOR_POSTCODE_APIPATH: '/fittingstation/getstations/',
    FITTING_STATIONS_FOR_TYRE_APIPATH: '/fittingstation/gettyrestations/',
    FITTING_STATIONS_REMOVE_APIPATH: '/api/v2/checkout/address/shipping/fittingstation/',
    POSTCODE_FROM_LAT_LNG_APIPATH: '/api/v2/addressing/streetaddresses/',
    GET_PRESELECTED_FITTING_STATION_API_URL: '/cart/calculateforid/',
    SET_FITTING_STATION_API_URL: '/cart/forcerecalculate/',
    SET_POSTCODE_API_URL: '/shipping/setaddress/',
    POST_ADD_TO_CART: '/cart/add/',
    MAP_VIEW: 2,
    LIST_VIEW: 1,
    MAPLIST_VIEW: 0,
};

export { FittingStationFinderConstants };
export default FittingStationFinderConstants;
